import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import { isNull, isArray, concat, trim, isUndefined } from 'lodash';

import * as Yup from 'yup';

import api from '~/services/api';
import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  Input,
  RadioGroup,
  Select,
} from '~/components/Form';
import { t, parseDateString } from '~/helpers';
import bico from '~/store/modules/bico/reducer';
import { FormatBoldOutlined } from '@material-ui/icons';

function Relabastecimento() {
  const [organ, setOrgan] = useState({ orga_codigo: '', orga_nome: '' });
  const [unity, setUnity] = useState({ unid_codigo: '', unid_nome: '' });

  const [open, setOpen] = useState(true);

  const [valueOrgao, setValueOrgao] = useState('');
  const [valueUnidade, setValueUnidade] = useState('');

  const [inputValueUnidade, setInputValueUnidade] = useState('');
  const [valuePosto, setValuePosto] = useState('');
  const [valueBico, setValueBico] = useState('');
  const [valueProduto, setValueProduto] = useState('');

  const [unidades, setUnidades] = useState([]);
  const [bicos, setBicos] = useState([]);

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const handleChangeUnity = useCallback((value) => {
    if (isNull(value.unid_nome)) setUnity({ unid_codigo: '', unid_nome: '' });
    else setUnity(value);
  }, []);

  // const handleChangeUnity = useCallback((value) => {
  //   if (isNull(value.unid_nome)) {
  //      setValueUnidade({ unid_codigo: '', unid_nome: '' });
  //   } else {
  //     setValueUnidade(value);
  //   }
  // }, []);

  const handleGetBicos = useCallback(async () => {
    try {
      const { data } = await api.get('bicos', {
        params: {
          wherefield: 'poco_codigo',
          valuewherefield: valuePosto.poco_codigo,
          typewherefield: 'EQUALS',
          pagesize: 99999,
          pesquisalista: true,
        },
      });

      setBicos(
        concat(
          [{ label: 'Todos', value: 'Todos' }],
          data.items.map((item) => ({
            label: item.bico_descricao,
            value: {
              value: item.bico_numero,
              bico: item.bico_descricao,
            },
          }))
        )
      );
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [valuePosto]);

  // useEffect(() => {
  //   if (!isNull(valueOrgao.orga_codigo) && !isUndefined(valueOrgao.orga_codigo)) {
  //     handleGetUnidades();
  //   } else {
  //     setUnidades([])
  //     setValueUnidade('')
  //   }
  // }, [valueOrgao])

  useEffect(() => {
    setValueBico('');
    if (
      !isNull(valuePosto.poco_codigo) &&
      !isUndefined(valuePosto.poco_codigo)
    ) {
      handleGetBicos();
    } else {
      setBicos([]);
      setValueBico('');
    }
  }, [valuePosto]);

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        // datahorainicial: Yup.string().required(
        //   t('s.geral.validacao.campoobrigatorio')
        // ),
        // datahorafinal: Yup.string().required(
        //   t('s.geral.validacao.campoobrigatorio')
        // )
        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(datahorafinal, `A data não pode ser superior a ${datahorafinal}`)
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior a Data inicial'
          ),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  const onSerializeData = useCallback(
    (data) => {
      if (valueBico.value == 'Todos') {
        setValueBico({ ...valueBico, value: '' });
      }

      if (valueUnidade.unid_codigo == 'Todos') {
        setValueUnidade({ ...valueUnidade, unid_codigo: '' });
      }

      return {
        ...data,
        unidade: unity.unid_codigo ? unity.unid_codigo : '',
        unidadestr: unity.unid_nome ? unity.unid_nome : '',
        orgao: organ.orga_codigo ? organ.orga_codigo : '',
        orgaostr: organ.orga_nome ? organ.orga_nome : '',
        posto: valuePosto.poco_codigo ? valuePosto.poco_codigo : '',
        postostr: valuePosto.poco_desc_abrev ? valuePosto.poco_desc_abrev : '',
        bico: valueBico.value ? valueBico.value : '',
        bicostr: valueBico.bico ? valueBico.bico : '',
        produto: valueProduto.prod_codigo ? valueProduto.prod_codigo : '',
        produtostr: valueProduto.prod_descricao
          ? valueProduto.prod_descricao
          : '',
        placa: data.placa ? data.placa : '',
        agrupamento: data.agrupamento ? data.agrupamento : '',
        condutor: data.condutor ? data.condutor : '',
        status: data.status ? data.status : '',
        statusstr: '',
      };
    },
    [organ, unity, valuePosto, valueBico, valueProduto]
  );

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Abastecimentos"
      relatorio="abastecimentos"
      serialize={onSerializeData}
      validate={handleValidate}
      initials={{
        datahorainicial,
        datahorafinal,
        agrupamento: '1',
        placa: '',
        condutor: '',
        status: 'T',
        agrupamento: '1',
      }}
    >
      {/* <DateTime time label="Data Inicial" name="datahorainicial" />
      <DateTime time label="Data Final" name="datahorafinal" /> */}

      <DateTime
        time
        label="Data Inicial"
        name="datahorainicial"
        disableFuture={true}
      />

      <DateTime
        time
        label="Data Final"
        name="datahorafinal"
        disableFuture={true}
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
      />

      <Autocomplete
        name="orgao"
        label="orga_nome"
        title="Órgão"
        url="orgaos"
        unique="orga_codigo"
        getValue={(value) => {
          setOrgan(value);
          setUnity({ unid_codigo: '', unid_nome: '' });
        }}
      />

      <Autocomplete
        includeInputInList
        disabledItemsFocusable
        disableClearable={!unity.unid_codigo}
        name="unidade"
        label="unid_nome"
        title="Unidade"
        url="unidades"
        unique="unid_codigo"
        params={{
          wherefield: ['orga_codigo'],
          valuewherefield: [organ.orga_codigo],
          typewherefield: ['EQUALS'],
        }}
        disabled={isNull(organ.orga_codigo)}
        getValue={handleChangeUnity}
        inputValue={unity.unid_nome}
        onInputChange={(event, value) => {
          let obj = {
            ...unity,
            unid_nome: value,
          };
          setUnity(obj);
        }}
      />

      {/* <Autocomplete
        name="orgao"
        label="orga_nome"
        title="Órgão"
        id="orga_codigo"
        url="orgaos"
        unique="orga_codigo"
        getValue={(value) => {
          setValueOrgao(value)
          setValueUnidade({ unid_codigo: undefined, unid_nome: undefined })
          setInputValueUnidade('')
        }}
      />

      <Autocomplete
        name="unidade"
        label="unid_nome"
        title="Unidade"
        url="unidades"
        getValue={handleChangeUnity}
        params={{
          wherefield: 'orga_codigo',
          valuewherefield: valueOrgao.orga_codigo,
          typewherefield: 'EQUALS',
          pagesize: 99999
        }}
        disabled={isNull(valueOrgao.orga_codigo)}
        inputValue={valueUnidade.unid_nome}
      /> */}

      <Autocomplete
        name="posto"
        label="poco_desc_abrev"
        title="Posto"
        id="poco_codigo"
        url="postoscomboios"
        unique="poco_codigo"
        getValue={(value) => {
          setValuePosto(value);
          setValueBico('');
        }}
      />

      <Select
        name="bico"
        label="Bico"
        options={bicos}
        disabled={
          isNull(valuePosto.poco_codigo) || isUndefined(valuePosto.poco_codigo)
        }
        getValue={(value) => {
          value ? setValueBico(value) : setValueBico('');
        }}
      />

      <Autocomplete
        name="produto"
        label="prod_descricao"
        title="Produto"
        id="prod_codigo"
        url="produtos"
        unique="prod_codigo"
        getValue={(value) => {
          setValueProduto(value);
        }}
      />

      <Input name="placa" label="Placa" inputProps={{ maxLength: 7 }} />
      <Input
        name="condutor"
        label="CPF Condutor"
        inputProps={{ maxLength: 11 }}
      />

      <Select
        name="status"
        variant="outlined"
        size="small"
        label="Status"
        //defaultValue="T"
        options={[
          { value: 'T', label: 'T - Todos' },
          { value: 'N', label: 'N - Normal' },
          { value: 'C', label: 'C – Liberação Gestor – Impedimento condutor' },
          { value: 'V', label: 'V – Liberação Gestor – Impedimento veículo' },
          {
            value: 'G',
            label: 'G – Liberação Gestor – Impedimento veículo e condutor',
          },
        ]}
      />

      <Select
        name="agrupamento"
        variant="outlined"
        size="small"
        label="Agrupamento"
        //defaultValue="1"
        options={[
          { value: '1', label: 'Listagem' },
          { value: '2', label: 'Data' },
          { value: '3', label: 'Órgão' },
          { value: '4', label: 'Unidade' },
          { value: '5', label: 'Posto' },
          { value: '6', label: 'Bico' },
          { value: '7', label: 'Produto' },
          { value: '8', label: 'Placa' },
          { value: '9', label: 'Condutor' },
          { value: '10', label: 'Status' },
        ]}
      />

      <RadioGroup
        name="formatoabastecimento"
        label="Tipo de relatório"
        options={[
          { label: 'Analítico', value: 'ANALITICO' },
          { label: 'Sintético', value: 'SINTETICO' },
        ]}
        defaultValue="ANALITICO"
        serialize={(value) => value}
        row
      />

      <RadioGroup
        name="tipo"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relabastecimento;
